/*
 * @Author: zhang lin
 * @Date: 2022-04-07 11:03:35
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-01-12 08:48:24
 * @Description: file content
 */
import { GET_CURRENT, SET_CURRENT, GET_CHECKFN, SET_OPERATE } from '../constant';

export const getCurrent = () => ({
  type: GET_CURRENT,
});

export const setCurrent = (payload: number) => ({
  type: SET_CURRENT,
  payload,
});

export const getCheckFn = () => ({
  type: GET_CHECKFN,
});

export const setOperate = (payload: string) => ({
  type: SET_OPERATE,
  payload,
});
